import React from 'react';

type Props = {
    isPlayer: boolean;
};

export const RankHead: React.FC<Props> = ({ isPlayer }) => {
    let headerNames: string[];

    if (isPlayer) {
        headerNames = ['Rank', 'SPIN Username', 'Grad Class', 'School', 'Rank', 'GPA'];
    } else {
        headerNames = ['Rank', 'School', 'City', 'Wins', 'Losses'];
    }

    return (
        <div className={`rankings-head${isPlayer ? '' : ' school'}`}>
            {headerNames.map((header, id) => (
                <div key={id} className={`rankings-heading`}>
                    {header}
                </div>
            ))}
        </div>
    );
};
